/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditSpotAuditSpotMatchesListQueryResponse, AuditSpotAuditSpotMatchesListQueryParams } from "../models/AuditSpotAuditSpotMatchesList";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditSpotAuditSpotMatchesList } from "../axios/auditSpotAuditSpotMatchesList";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditSpotAuditSpotMatchesListQueryKey = (params: AuditSpotAuditSpotMatchesListQueryParams) => ["api-v2", { url: '/audit-spot/v1/matches' }, ...(params ? [params] : [])] as const

export type AuditSpotAuditSpotMatchesListQueryKey = ReturnType<typeof auditSpotAuditSpotMatchesListQueryKey>

export function auditSpotAuditSpotMatchesListQueryOptions(params: AuditSpotAuditSpotMatchesListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditSpotAuditSpotMatchesListQueryKey(params)
        return queryOptions<AuditSpotAuditSpotMatchesListQueryResponse, ResponseErrorConfig<Error>, AuditSpotAuditSpotMatchesListQueryResponse, typeof queryKey>({
         enabled: !!(params),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditSpotAuditSpotMatchesList(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns paginated spot matches using the mi-api CRUD list contract. Requires `filter=datetime||$gte||<from>` and `filter=datetime||$lte||<to>`. Optional filters: `customId||$eq||<id>`. Sort with `sort=datetime,ASC|DESC`.
 * @summary List spot matches
 * {@link /audit-spot/v1/matches}
 */
export function useAuditSpotAuditSpotMatchesList<TData = AuditSpotAuditSpotMatchesListQueryResponse, TQueryData = AuditSpotAuditSpotMatchesListQueryResponse, TQueryKey extends QueryKey = AuditSpotAuditSpotMatchesListQueryKey>(params: AuditSpotAuditSpotMatchesListQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AuditSpotAuditSpotMatchesListQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditSpotAuditSpotMatchesListQueryKey(params)
         

         const query = useQuery({
          ...auditSpotAuditSpotMatchesListQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}